module.exports = __webpack_public_path__ + "static/media/2.008ad339.png";